const availableLanguages = ['en'];
const defaultLanguage = 'en';

export default availableLanguages;
export { defaultLanguage };
